import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgIconSolidInfo = (props) => /* @__PURE__ */ _jsxs("svg", {
	viewBox: "0 0 16 16",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsx("rect", {
		width: 16,
		height: 16,
		rx: 8,
		fill: "currentColor"
	}), /* @__PURE__ */ _jsx("path", {
		d: "M8.8827 3.37036C9.39034 3.37036 9.85184 3.78912 9.85184 4.34747C9.85184 4.62664 9.75954 4.85929 9.57494 5.0454C9.1596 5.32458 8.55966 5.23152 8.23661 4.81276C7.95972 4.44053 7.95972 3.97524 8.23661 3.60301C8.42121 3.46342 8.65195 3.37036 8.8827 3.37036ZM9.29804 6.39474L7.95972 11.0476C7.91357 11.2338 7.86742 11.3733 7.86742 11.5595C7.86742 11.606 7.91357 11.6525 7.91357 11.699C7.95971 11.7456 8.00586 11.7456 8.05201 11.7456C8.14431 11.7456 8.23661 11.699 8.28276 11.6525C8.55966 11.3733 8.7904 11.0942 8.975 10.7685L9.1596 10.908C8.51351 12.0713 7.82127 12.6296 7.08288 12.6296C6.85213 12.6296 6.57524 12.5831 6.39064 12.397C6.20604 12.2574 6.11374 12.0247 6.15989 11.7921C6.15989 11.5595 6.20604 11.3733 6.25219 11.1872L7.17518 8.02325C7.26748 7.79061 7.31363 7.55797 7.31363 7.32532C7.31363 7.23226 7.26748 7.1392 7.17518 7.09268C7.08288 6.99962 6.94443 6.95309 6.85213 6.99962H6.62139L6.71368 6.72044L8.92885 6.34821L9.29804 6.39474Z",
		fill: "white"
	})]
});
export default SvgIconSolidInfo;
